<template>
  <div class="global-box banner diff bottom">
    <div class="content-box">
      <div class="text">
        <h1>
          {{$t('index.benefits.call')}}
        </h1>
        <p>
          {{$t('index.benefits.description')}}
        </p>
        <p>
          {{$t('index.benefits.description_complement')}}
        </p>
      </div>
      <div class="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data() {
    return {

    };
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .banner
    min-height: 340px
    background-color: $primary
    overflow: initial !important
    position: relative
    margin-bottom: 44px
    .content-box
      height: 260px
      .text
        width: 40%
        h1
          font-size: 22px
          text-decoration: none
          text-align: center
          text-transform: lowercase
          margin-bottom: 16px
          padding: 0 20px
        p
          font-size: 18px
          color: $grey-800
          text-align: justify
          &:last-child
            margin-top: 12px
      .image
        width: 40%
        height: 100%
        background-image: url(../assets/images/bitmap.png)
        background-size: 550px auto
        background-repeat: no-repeat
        position: absolute
        right: 0
        top: 0
    @media (max-width: $widthTerciary)
      padding-bottom: 0 !important
      .content-box
        height: auto
        .text
          width: 100%
        .image
          height: 372px
          width: 100%
          position: relative
          margin-top: 32px
</style>
